// @ts-nocheck
import React from 'react';

const Textarea = React.forwardRef(({
  className = '',
  invalid,
  rows = 4,
  ...rest
}, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    className={[
      'w-full bg-mov-paper-2 border rounded-md2 px-3 py-2.5 text-[13px] text-mov-ink',
      'placeholder:text-mov-ink-mute outline-none resize-y',
      'transition-[border-color,box-shadow,background] duration-150',
      'mov-input-hover mov-textarea-focus',
      invalid ? 'mov-input-invalid' : 'border-mov-line-strong',
      className,
    ].join(' ')}
    {...rest}
  />
));
Textarea.displayName = 'Textarea';

export default Textarea;
